import { mapNotifications } from '@/shared/services/notification/helps';
import sdkNotificationService, { Origin } from '@/app/graphql/notification/notification';

export async function readAllMessage() {
  return await sdkNotificationService.readAll();
}

export async function findAllMessages() {
  const response = await sdkNotificationService.findAll();
  if (response.findAll) return mapNotifications(response.findAll);
  return [];
}
export async function deleteAllMessage() {
  return await sdkNotificationService.deleteAll();
}

export async function deleteMessage(notificationId: number) {
  return await sdkNotificationService.delete({ notificationId });
}

export async function deleteMultipleMessage(notificationIdList: number[]) {
  return await sdkNotificationService.deleteMultiple({ notificationIdList });
}

export async function readAllByOrigin(origin: Origin) {
  return await sdkNotificationService.readAllByOrigin({ origin });
}

export async function readMessage(notificationId: number) {
  return await sdkNotificationService.read({ notificationId });
}

export async function existNewNotifications() {
  const response = await sdkNotificationService.existNewNotifications();
  return response.existNewNotifications;
}
